/* eslint-disable */
const $ = (global.jQuery = require('jquery'))

// import 'babel-polyfill';
import 'whatwg-fetch'
import 'lazysizes/plugins/bgset/ls.bgset'
import 'lazysizes'

import AOS from 'aos'
AOS.init()

import './touch'
import './components/header'
import './components/nav'
import './components/home-links-accordion'
import './components/property-details-tabs'
import './components/sticky'
import './components/popup'
import './components/gtm'
import './components/form-validation'
import './components/toggle-visibility'
import './components/delete-user'
import './components/form-autosubmit'
import './components/dismiss'
import './font-tracking'
import './components/property-wishlist'
import Attachment from './components/attachment'
import 'tablesaw/dist/tablesaw'
import './font-tracking'
import './components/subscribe-popup'
import './components/appraisal-request'
import './components/smooth-anchor'

const loadIf = (...elements) => {
    let load = false
    elements.forEach((element) => {
        if (document.querySelector(element)) load = true
    })
    return load
}

if (loadIf('.js-date-range')) {
    import('./components/date-range' /* webpackChunkName: "date-range" */).then(
        (module) => new module.default()
    )
}

if (loadIf('.js-form-validate')) {
    import('./components/forms' /* webpackChunkName: "forms" */).then(
        (module) => new module.default()
    )
}

if (loadIf('.js-property-card')) {
    import(
        './components/property-card' /* webpackChunkName: "property-card" */
    ).then((module) => module.default())
}

// Conditionally load search (on homepage and search)
if (loadIf('#suburb-select-static', '#search-results', '.js-property-alert')) {
    import('./components/search' /* webpackChunkName: "search" */).then(
        (module) => new module.default()
    )
}

if (loadIf('select')) {
    import('./components/select2' /* webpackChunkName: "select2" */).then(
        (module) => module.default()
    )
}

if (
    loadIf(
        '.js-review-slider',
        '.js-carousel-main',
        '.js-floorplan',
        '.js-carousel-back'
    )
) {
    import('./components/carousel' /* webpackChunkName: "carousel" */).then(
        (module) => module.default()
    )
}

if (loadIf('.js-steps-section')) {
    import(
        './components/steps-section' /* webpackChunkName: "steps-section" */
    ).then((module) => module.default())
}

if (loadIf('#fields-preferredMaintenanceDate')) {
    import('pikaday' /* webpackChunkName: "pikaday" */).then((module) => {
        const picker = new module.default({
            field: document.getElementById('fields-preferredMaintenanceDate'),
            format: 'D MMM YYYY',
        })
    })
}

$('.fui-type-file-upload').each(function (index, value) {
    new Attachment(value)
})

// Opening hours
$('.js-hours').on('click', function () {
    $(this).next('ul.hours__list').toggle()
})

// Emergency table repairs
$('.js-table').on('click', function () {
    $(this).next('.table-content').toggle()
})

$('.js-sidebar').on('click', function () {
    $('body').toggleClass('sidebar-active')
})

$('.js-overlay, .js-sidebar-close').on('click', function () {
    $('body').removeClass('sidebar-active')
})

// On submit newsletter change submit button
$('.footer__subscribe #mce-success-response').bind(
    'DOMSubtreeModified',
    function () {
        $('.footer__subscribe').addClass('footer__subscribe--submitted')
        $('#mc-embedded-subscribe').val('Thanks')
    }
)

// Scroll to next container
$('.js-scroll-next').click(function () {
    const $target = $(this).parent().next()

    $('html, body').animate(
        {
            scrollTop: $target.offset().top,
        },
        800
    )
    return false
})

// Checkboxes
$('.checkboxes input[type="checkbox"]').on('change', function () {
    var $label = $(this).closest('label')
    if ($(this).is(':checked')) {
        $label.addClass('is-checked')
    } else {
        $label.removeClass('is-checked')
    }
})
